// Which reward machine a trip uses (B16): the parent's choice for this trip, else the region kit's,
// else the neutral one. The machine only changes the look and the words; the economy is the same.
import type { Pack } from './pack/schema'
import { NEUTRAL_MACHINE, RewardMachineId } from './rewards'

export function rewardMachineFor(pack: Pick<Pack, 'meta'>): RewardMachineId {
  for (const id of [pack.meta.rewardMachine, pack.meta.reward?.machine]) {
    const ok = RewardMachineId.safeParse(id)
    if (ok.success) return ok.data
  }
  return NEUTRAL_MACHINE
}
